import * as types from '../mutation-types'
import userService from '../../services/users'

const state = {
    loading: false,
    errors: '',
    teachers: [],
}

const actions = {
    getAll({ commit }) {
        commit(types.TEACHER_LOADING, true)
        userService.getAll({ utype: "tca" }).then(
            response => {

                commit(types.LOAD_TEACHERS, response.data)
                commit(types.TEACHER_LOADING, false)
                commit(types.TEACHER_FAILURE, null)
            },
            error => {
                commit(types.TEACHER_FAILURE, error)
                commit(types.TEACHER_LOADING, false)
            }
        )
    },
    add({ commit }, data) {

        commit(types.TEACHER_LOADING, true)
        commit(types.TEACHER_FAILURE, null)
        userService.add(data).then(
            response => {
                console.log(response)

                data.id = response.data.id
                data.roles = response.data.roles
                commit(types.ADD_TEACHER, data)
                commit(types.TEACHER_LOADING, false)

            },
            error => {
                commit(types.TEACHER_FAILURE, error)
                commit(types.TEACHER_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.TEACHER_LOADING, true)
        commit(types.TEACHER_FAILURE, null)
        userService.update(data.employee)
            .then(
                response => {
                    data.employee.roles = response.data.roles
                    commit(types.UPDATE_TEACHER, data)
                    commit(types.TEACHER_LOADING, false)

                },
                error => {
                    commit(types.TEACHER_FAILURE, error)
                    commit(types.TEACHER_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.TEACHER_LOADING, true)
        userService.delete(data.employee.id)
            .then(
                response => {

                    commit(types.DELETE_TEACHER, data)
                    commit(types.TEACHER_FAILURE, null)
                    commit(types.TEACHER_LOADING, false)
                },
                error => {
                    commit(types.TEACHER_FAILURE, error)
                    commit(types.TEACHER_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_TEACHER](state, payload) {
        state.teachers.unshift(payload);
    },
    [types.LOAD_TEACHERS](state, payload) {
        state.teachers = payload
    },
    [types.UPDATE_TEACHER](state, payload) {
        Object.assign(state.teachers[payload.index], payload.employee);
    },
    [types.DELETE_TEACHER](state, payload) {
        state.teachers.splice(payload.index, 1)
    },
    [types.TEACHER_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.TEACHER_LOADING](state, payload) {
        state.loading = payload
    },
}


const getters = {
    TEACHERS: state => {
        return state.teachers
    },

    TEACHER_ERROR: state => {
        return state.errors
    },

    TEACHER_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/teachers.js